import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'toggle']

  connect() {
    // A filter change navigates the table's turbo frame, which replaces
    // this form (and reconnects this controller from scratch) — persist the
    // user's open/closed choice across that so filtering doesn't visually
    // close the panel on mobile.
    this._storageKey = `table--filter-panel:${this.element.dataset.turboFrame ?? ''}`
    const stored = sessionStorage.getItem(this._storageKey)
    this.userToggled = stored !== null
    this.collapsed = stored === 'true'

    this._onResize = () => this.#syncDefaultState()
    window.addEventListener('resize', this._onResize)

    this.#syncDefaultState()
    this.#applyState()
  }

  disconnect() {
    window.removeEventListener('resize', this._onResize)
  }

  toggle() {
    this.userToggled = true
    this.collapsed = !this.collapsed
    sessionStorage.setItem(this._storageKey, String(this.collapsed))
    this.#applyState()
  }

  #syncDefaultState() {
    const isMobileOrTablet = window.matchMedia('(max-width: 1024px)').matches

    if (!isMobileOrTablet) {
      this.collapsed = false
      this.#applyState()
      return
    }

    if (!this.userToggled) {
      this.collapsed = true
      this.#applyState()
    }
  }

  #applyState() {
    if (this.hasPanelTarget) {
      this.panelTarget.hidden = this.collapsed
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.textContent = this.collapsed ? 'Show filters' : 'Hide filters'
      this.toggleTarget.setAttribute('aria-expanded', String(!this.collapsed))
    }
  }
}
